import type { paths } from '@luxuryescapes/contract-svc-content';

export type TermsAndConditionsBrand =
  paths['/api/content/terms-and-conditions/{brand}']['get']['parameters']['path']['brand'];

/** svc-content's brand list limited to those relevant to terms and conditions. */
export const TERMS_AND_CONDITIONS_BRANDS: Array<{ value: TermsAndConditionsBrand; label: string }> = [
  { value: 'luxuryescapes', label: 'Luxury Escapes' },
  { value: 'lebusinesstraveller', label: 'LE Business Traveller' },
];

export const DEFAULT_TERMS_AND_CONDITIONS_BRAND: TermsAndConditionsBrand = 'luxuryescapes';

export const termsAndConditionsBrandLabel = (brand: string): string =>
  TERMS_AND_CONDITIONS_BRANDS.find((option) => option.value === brand)?.label ?? brand;

export const DEFAULT_TERMS_AND_CONDITIONS_LOCALE = 'en-AU';

export const TERMS_AND_CONDITIONS_LOCALES: Array<{ value: string; label: string }> = [
  { value: DEFAULT_TERMS_AND_CONDITIONS_LOCALE, label: 'English (en-AU)' },
  { value: 'fr-FR', label: 'French (fr-FR)' },
  { value: 'de-DE', label: 'German (de-DE)' },
  { value: 'ar-SA', label: 'Arabic (ar-SA)' },
];

const RTL_TERMS_AND_CONDITIONS_LOCALES = new Set(['ar-SA']);

export const isRtlTermsAndConditionsLocale = (locale: string): boolean => RTL_TERMS_AND_CONDITIONS_LOCALES.has(locale);

export const TERMS_AND_CONDITIONS_SLUG_PATTERN = /^[a-z0-9]+(-[a-z0-9]+)*$/;

export const TERMS_AND_CONDITIONS_SLUG_MAX_LENGTH = 255;
